<template>
  <v-container fluid class="gl-map-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn to="/gl-map/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="gl-maps-table"
              show-select
              single-select
              item-key="_id"
              sort-by="map"
              :footer-props="footer"
              :headers="header_maps"
              :items="glmaps"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDelete"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Map?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_map.mapname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDelete = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_map)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.mapimage" size="35">
                  <img v-bind:src="item.mapimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.mapname[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.mapname="{ item }">
                <p class="two-line"><a class="primaryConst--text">{{ item.mapname }}</a></p>
                <p class="two-line">{{ item.mapinfo }}</p>
              </template>
              <template v-slot:item.mapstatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.mapstatus)"
                  small>
                  {{ item.mapstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '@/util/tools';

export default {
  name: 'GLMapList',
  data() {
    return {
      config,
      snackbar: null,
      isDelete: false,
      delete_map: {},
      header_maps: [
        { text: 'Type', value: 'maptype', width: "10%"  },
        { text: 'Code', value: 'mapcode' },
        { text: 'Name', value: 'mapname' },
        { text: 'Status', value: 'mapstatus', width: "10%"  },
        { text: 'Create', value: 'createdAt', width: "10%"  },
        { text: 'Actions', value: 'actions', sortable: false, width: "10%" },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      getStatusColor: getStatusColor
    }
  },
  computed: {
    ...mapState('GLMap', ['glmaps', 'isReceiving', 'isDeleting', 'idToDelete', 'glmapsMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('GLMap', ["getGLMapsRequest","deleteGLMapRequest","updateGLMapRequest","insertGLMapRequest"]),
    editItem(item) {
      this.$router.push({ name: 'GLMapEdit', params: item })
    },
    deleteItem(item) {
      this.deleteGLMapRequest(item);
      this.isDelete = false;
    },
    deleteDialog(item) {
      this.isDelete = true;
      this.delete_map = {
        _id: item._id,
        mapname: item.mapname,
      }
    },
  },
  async created () {
    await this.getGLMapsRequest()
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
